import PersonalResourceComponent from '../PersonalResourceComponent.vue'

export default [
    {
        path: '/personal_resources',
        name: 'PersonalResources',
        meta: { layout: 'default' },
        component: PersonalResourceComponent,
    },
]